import { LoginForm } from '@shared/features/auth/components/LoginForm';

export default function LoginPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="flex justify-center">
        <LoginForm />
      </div>
    </div>
  );
}